import { gql } from '../__generated__';

export const GET_CONVERSATIONS = gql(`
  query GetMessagesByProspectId {
    Messages(where: {sentOn: {_is_null: false}}, order_by: [{prospectId: desc}, {sentOn: desc}], distinct_on: prospectId) {
      prospectId
      sentOn
      fullName
      content
      id
      actionType
      linkedinUserId
      prospectFullName
      deliveryStatus
      Attachments {
        type
        value
      }
      OutreachSuggestion {
        id
      }
    }
  }
`);

export const GET_ACTIONS_BY_PROSPECT_IDS = gql(`
    query GetActionsByProspectIds(
        $limit: Int
        $scheduledOnLt: timestamp
        $prospectIds: [String!]!
    ) {
        OutreachSuggestions(
            limit: $limit
            where: {
                scheduledOn: { _lt: $scheduledOnLt }
                Message: { sentOn: { _is_null: true } }
                prospectId: { _in: $prospectIds }
            }
            order_by: [{ Message: { createdAt: desc } }]
        ) {
            id 
            createdAt
            prospectId
            accountName
            name
            unread
            isGenerating
            goal
            conversationPaths
            Message {
                content
                subjectLine
            }
            ConversationMetaData {
                id
                numberOfMessages
                isNextMessageFollowUp
                messagesPerDay
                lastNetworkUpdateAt
                youThemMessageRatio
                lastUserNoteAt
                hasMessagesSentFromApp
                medianMessageLength
                connectionStatus
                lastTimeToAnswer
                userContactAddedAt
                lastMessageAt
                numberOfMessagesLastDay
                numberOfMessagesLastWeek
                userContactFromOnboarding
                createdAt
                updatedAt
                topics
            }
        }
    }
`);

export const GET_ACTIONS = gql(`
    query GetActions(
        $limit: Int
        $scheduledOnLt: timestamp
    ) {
        OutreachSuggestions(
            limit: $limit
            where: {
                scheduledOn: { _lt: $scheduledOnLt }
                Message: { sentOn: { _is_null: true } }
            }
            order_by: [{ Message: { createdAt: desc } }]
        ) {
            id 
            createdAt
            prospectId
            accountName
            name
            unread
            isGenerating
            goal
            conversationPaths
            Message {
                content
                subjectLine
            }
            ConversationMetaData {
                id
                numberOfMessages
                isNextMessageFollowUp
                messagesPerDay
                lastNetworkUpdateAt
                youThemMessageRatio
                lastUserNoteAt
                hasMessagesSentFromApp
                medianMessageLength
                connectionStatus
                lastTimeToAnswer
                userContactAddedAt
                lastMessageAt
                numberOfMessagesLastDay
                numberOfMessagesLastWeek
                userContactFromOnboarding
                createdAt
                updatedAt
                topics
            }
        }
    }
`);

export const GET_COMPLETED_ACTIONS = gql(`
    query GetCompletedActions(
        $limit: Int
        $scheduledOnLt: timestamp
        $completedOnGte: timestamp
    ) {
        OutreachSuggestions(
            limit: $limit
            where: {
                scheduledOn: { _lt: $scheduledOnLt }
                Message: { sentOn: { _is_null: false, _gte: $completedOnGte } }
            }
            order_by: { Message: { sentOn: desc } }
        ) {
            id
            createdAt
            prospectId
            accountName
            name
            goal
            Message {
                content
                subjectLine
                actionType
            }
            ConversationMetaData {
                topics
            }
        }
    }
`);

export const GET_OUTREACH_SUGGESTION_PATHS_BY_PROSPECT_ID = gql(`
query GetOutreachSuggestionPathsByProspectId($prospectId: String!, $scheduledOnLt: timestamp) {
  OutreachSuggestions(where: {prospectId: {_eq: $prospectId}, scheduledOn: {_lt: $scheduledOnLt}, Message: { sentOn: { _is_null: true } }}, order_by: {createdAt: desc}) {
    conversationPaths
  }
}
`);

export const GET_OUTREACH_SUGGESTIONS = gql(`
query GetOutreachSuggestions($limit: Int, $notYetSent: Boolean! = true ,$scheduledOnLt: timestamp!, $sentOnGte: timestamp!) {
  focus: OutreachSuggestions(limit: $limit, where: {Message: {sentOn: {_is_null: $notYetSent}}, scheduledOn: {_lt: $scheduledOnLt}}) {
    accountName
    accountWebsite
    email
    linkedinUrl
    numberOfEmployees
    title
    name
    industry
    contactLocation
    id
    updatedAt
    createdAt
    prospectId
    unread
    Message {
      id
      subjectLine
      content
      actionType
      channelType
    }
    ConversationMetaData {
      id
      numberOfMessages
      isNextMessageFollowUp
      messagesPerDay
      lastNetworkUpdateAt
      youThemMessageRatio
      lastUserNoteAt
      hasMessagesSentFromApp
      medianMessageLength
      connectionStatus
      lastTimeToAnswer
      userContactAddedAt
      userContactFromOnboarding
      lastMessageAt
      numberOfMessagesLastDay
      numberOfMessagesLastWeek
      createdAt
      updatedAt
    }
  
  }
  completed: OutreachSuggestions(limit: $limit, where: {Message: {sentOn: {_is_null: false, _gte: $sentOnGte}}, scheduledOn: {_lt: $scheduledOnLt}}) {
    accountName
    accountWebsite
    email
    linkedinUrl
    numberOfEmployees
    title
    name
    industry
    contactLocation
    id
    updatedAt
    createdAt
    prospectId
    unread
    Message {
      id
      subjectLine
      content
      actionType
      channelType
    }
    ConversationMetaData {
      id
      numberOfMessages
      isNextMessageFollowUp
      messagesPerDay
      lastNetworkUpdateAt
      youThemMessageRatio
      lastUserNoteAt
      hasMessagesSentFromApp
      medianMessageLength
      connectionStatus
      lastTimeToAnswer
      userContactAddedAt
      createdAt
      updatedAt
    }
  }
  focusCount: OutreachSuggestions_aggregate(limit: $limit, where: {Message: {sentOn: {_is_null: $notYetSent}}, scheduledOn: {_lt: $scheduledOnLt}}) {
    aggregate {
      count
    }
  }
  completedCount: OutreachSuggestions_aggregate(limit: $limit, where: {Message: {sentOn: {_is_null: false}}, scheduledOn: {_lt: $scheduledOnLt}}) {
    aggregate {
      count
    }
  }
}
`);

export const GET_OUTREACH_SUGGESTIONS_BY_PROSPECT_ID = gql(`
query GetOutreachSuggestionsByProspectId($prospectId: String!, $scheduledOnBefore: timestamp!) {
  focus: OutreachSuggestions(where: {prospectId: {_eq: $prospectId}, scheduledOn: { _lt: $scheduledOnBefore }, Message: {sentOn: {_is_null: true}}}, order_by: {Message: {createdAt: desc}}) {
    id
    updatedAt
    createdAt
    Message {
      id
      subjectLine
      content
      actionType
      channelType
    }
  }
  completed: OutreachSuggestions(where: {prospectId: {_eq: $prospectId}, scheduledOn: {_lt: $scheduledOnBefore}, Message: {sentOn: {_is_null: false}}}, order_by: {Message: {createdAt: desc}}) {
    id
  }
  future: OutreachSuggestions(where: {prospectId: {_eq: $prospectId}, scheduledOn: {_gt: $scheduledOnBefore}, Message: {sentOn: {_is_null: true}}}, order_by: {Message: {createdAt: desc}}) {
    id
    scheduledOn
    scheduledOnMotivation
  }
  unscheduled: OutreachSuggestions(where: {prospectId: {_eq: $prospectId}, scheduledOn: {_is_null: true}, Message: {sentOn: {_is_null: true}}}, order_by: {Message: {createdAt: desc}}) {
    id
  }
}
`);

export const GET_ACTIVE_OUTREACH_SUGGESTION_BY_PROSPECT_IDS = gql(`
query GetActiveOutreachSuggestionByProspectIds($prospectIds: [String!]!) {
  OutreachSuggestions(where: {prospectId: {_in: $prospectIds}, scheduledOn: {_is_null: false}, Message: {sentOn: {_is_null: true}}}, order_by: {Message: {createdAt: desc}}) {
    id
    prospectId
  }
}
`);

export const GET_CONTACT_SUGGESTIONS = gql(`
query GetContactSuggestions {
  ContactSuggestions(
    where: {approvedAt: {_is_null: true}, rejectedAt: {_is_null: true}, expiresAt: {_gt: "now()"}},
    order_by: {createdAt: desc}
  ) {
    id
    contactName
    reason
    personId
    organizationId
    contactEmailVerified
    contactLinkedinUrl
    contactEmail
    contactTitle
    contactLocation
    campaignId
    campaignName
    accountIndustry
    accountWebsite
    accountTags
    accountName
    accountId
    accountAboutUs
    accountNumberOfEmployees
    userId
    groupId
    prospectId
    suggestionMotivation
    contactImgUrl
  }
}
`);

export const GET_CONTACT_SUGGESTION_BY_ID = gql(`
query GetContactSuggestionById($id: String!) {
  ContactSuggestions(where: {id: {_eq: $id}}) {
    id
    contactName
    reason
    personId
    organizationId
    contactEmailVerified
    contactLinkedinUrl
    contactEmail
    contactTitle
    contactLocation
    campaignId
    campaignName
    accountIndustry
    accountWebsite
    accountTags
    accountName
    accountId
    accountAboutUs
    accountNumberOfEmployees
    userId
    groupId
    prospectId
    suggestionMotivation
    contactImgUrl
  }
}
`);

export const GET_CONTACT_SUGGESTIONS_BY_GROUP_ID = gql(`
query GetContactSuggestionsByGroupId($groupId: String!) {
  ContactSuggestions(
    where: {approvedAt: {_is_null: true}, rejectedAt: {_is_null: true}, expiresAt: {_gt: "now()"}, groupId: {_eq: $groupId}},
    order_by: {createdAt: desc}
  ) {
    id
    contactName
    reason
    personId
    organizationId
    contactEmailVerified
    contactLinkedinUrl
    contactEmail
    contactTitle
    contactLocation
    campaignId
    campaignName
    accountIndustry
    accountWebsite
    accountTags
    accountName
    accountId
    accountAboutUs
    accountNumberOfEmployees
    userId
    groupId
    prospectId
    suggestionMotivation
    contactImgUrl
  }
}
`);

export const GET_CONTACT_SUGGESTIONS_COUNT = gql(`
query GetContactSuggestionsCount {
  ContactSuggestions_aggregate(
    where: {approvedAt: {_is_null: true}, rejectedAt: {_is_null: true}, expiresAt: {_gt: "now()"}}
  ) {
    aggregate {
      count
    }
  }
}
`);

export const GET_OUTREACH_SUGGESTION_BY_PK = gql(`
query GetOutreachSuggestionById($id: String!) {
  OutreachSuggestions_by_pk(id: $id) {
    Message {
      id
      direction
      conversationId
      prospectId
      channelType
      actionType
      contentType
      subjectLine
      content
      sentOn
      fullName
      approvedAt
      linkedinUserId
      prospectFullName
      }
    id
    email
    name
    accountName
    unread
    industry
    contactLocation
    prospectId
    linkedinUrl
  }
}
`);

// get all messages for a prospect
export const GET_PROSPECT_MESSAGES_HISTORY = gql(`
query GetProspectMessagesHistory($prospectId: String!) {
  Messages(where: {prospectId: {_eq: $prospectId}, sentOn: {_is_null: false}}, order_by: [{sentOn: asc_nulls_last}]) {
    id
    direction
    conversationId
    prospectId
    channelType
    actionType
    contentType
    subjectLine
    content
    sentOn
    fullName
    direction
    channelType
    linkedinUserId
    externalMessageId
    prospectFullName
    deliveryStatus
    Attachments {
        type
        value
      }
  }
}
`);

export const GET_PROSPECT_NOTES = gql(`
query GetProspectNotes($prospectId: String!) {
  Notes(where: {prospectId: {_eq: $prospectId}, discarded: {_eq: false}}, order_by: [{createdAt: asc_nulls_last}]) {
    id
    content
    prospectId
    title
    userId
    createdAt
    updatedAt
    creator
    happenedOn
  }
}
`);

export const GET_NOTE_BY_ID = gql(`
query GetNoteById($noteId: String!) {
  Notes(where: {id: {_eq: $noteId}, discarded: {_eq: false}}) {
    id
    content
    prospectId
    title
    userId
    createdAt
    updatedAt
    creator
  }
}
`);

export const GET_ALL_PROSPECT_SUBJECT_LINES = gql(`
query GetAllProspectSubjectLines($prospectId: String!) {
  Messages(where: {prospectId: {_eq: $prospectId}, sentOn: {_is_null: false}}, order_by: [{sentOn: desc_nulls_last}]) {
    id
    subjectLine
  }
}
`);

export const GET_LAST_PROSPECT_MESSAGE = gql(`
  query GetLastProspectMessage($prospectId: String!) {
    Messages(
      where: { prospectId: { _eq: $prospectId }, sentOn: { _is_null: false } }
      order_by: { sentOn: desc }
      limit: 1
    ) {
      id
      direction
      conversationId
      prospectId
      channelType
      actionType
      contentType
      subjectLine
      content
      sentOn
      fullName
      channelType
      linkedinUserId
      externalMessageId
      prospectFullName
      deliveryStatus
    }
  }
`);

export const GET_MESSAGES_SENT_FROM_APP = gql(`
query GetMessagesSentFromApp {
  Messages_aggregate(where: {isSentFromApp: {_eq: true}, sentOn: {_is_null: false}, direction: {_eq: "out"}}) {
    aggregate {
      count
    }
  }
}
`);

export const GET_ASSISTANT_SETTINGS = gql(`
    query GetAssistantSettings {
        AssistantSettings {
            id
            userId
            organizationId
            purpose
            language
            languages
            tone
            context
            createdAt
            updatedAt
        }
    }
`);

export const GET_GROUPS = gql(`
    query Groups {
        Groups(order_by: {createdAt: asc}) {
            id
            userId
            default
            name
            assistantSettingsId
            imgSrc
            createdAt
            updatedAt
        }
    }
`);

export const GET_USER_CONTACTS_BY_GROUP_IDS = gql(`
    query GetUserContactsByGroupIds($groupIds: [String!] $orderBy: [UserContacts_order_by!] = [{createdAt: desc}] ) {
        UserContacts(where: {_GroupToUserContacts: {Group: {id: {_in: $groupIds}}}}, order_by: $orderBy) {
            id
            prospectId
            status
            createdAt
            _GroupToUserContacts {
                Group {
                    id
                    name
                    imgSrc
                }
            }
        }
        totalCount: UserContacts_aggregate(where: {_GroupToUserContacts: {Group: {id: {_in: $groupIds}}}}) {
            aggregate {
                count
            }
        }
    }
`);

export const GET_USER_CONTACTS_PROSPECT_IDS_BY_GROUP_IDS = gql(`
    query GetUserContactsProspectIdsByGroupIds($groupIds: [String!] $orderBy: [UserContacts_order_by!] = [{createdAt: desc}] ) {
        UserContacts(where: {_GroupToUserContacts: {Group: {id: {_in: $groupIds}}}}, order_by: $orderBy) {
            prospectId
        }
    }
`);

export const GET_USER_CONTACT_BY_PROSPECT_ID = gql(`
    query GetUserContactByProspectId($prospectId: String!) {
        UserContacts(where: {prospectId: {_eq: $prospectId}}) {
            id
            userId
            prospectId
            createdAt
            updatedAt
            status
            _GroupToUserContacts {
                Group {
                    id
                    userId
                    name
                    default
                    assistantSettingsId
                    imgSrc
                    createdAt
                    updatedAt
                }
            }
        }
    }
`);

export const GET_USER_CONTACT_IDS_BY_PROSPECT_IDS = gql(`
    query GetUserContactIdsByProspectIds($prospectIds: [String!]!) {
        UserContacts(where: {prospectId: {_in: $prospectIds}}) {
            id
            prospectId
        }
    }
`);

export const GET_TOTAL_NUMBER_OF_USER_CONTACTS = gql(`
    query GetTotalNumberOfUserContacts {
        UserContacts_aggregate {
            aggregate {
                count
            }
        }
    }
`);

export const GET_TOTAL_NUMBER_OF_USER_CONTACTS_IN_ANY_PLAYBOOK = gql(`
    query GetTotalNumberOfUserContactsInAnyPlaybook {
        UserContacts_aggregate(where: {_GroupToUserContacts: {Group: {id: {_is_null: false}}}}) {
            aggregate {
                count
            }
        }
    }
`);
export const GET_USER_CONTACT = gql(`
    query GetUserContactById($userContactId: String!) {
        UserContacts(where: {id: {_eq: $userContactId}}) {
            id
            userId
            prospectId
            createdAt
            updatedAt
            status
            _GroupToUserContacts {
                Group {
                    id
                    userId
                    name
                    default
                    assistantSettingsId
                    imgSrc
                    createdAt
                    updatedAt
                }
            }
        }
    }
`);
export const GET_USER_CONTACTS_BY_IDS = gql(`
query GetUserContactsByIds($ids: [String!]) {
        UserContacts(where: {id: {_in: $ids}}) {
            id
            userId
            prospectId
            createdAt
            updatedAt
            status
            _GroupToUserContacts {
                Group {
                    id
                    userId
                    name
                    default
                    assistantSettingsId
                    imgSrc
                    createdAt
                    updatedAt
                }
            }
        }
    }
`);

export const GET_ALL_USER_CONTACTS_IN_ANY_PLAYBOOK = gql(`
    query GetAllUserContactsInAnyPlaybook(
        $orderBy: [UserContacts_order_by!] = [{createdAt: desc}]
    ) {
        UserContacts(
            where: {_GroupToUserContacts: {Group: {id: {_is_null: false}}}}
            order_by: $orderBy
        ) {
            id
            prospectId
            status
            createdAt
            _GroupToUserContacts {
                Group {
                    id
                    name
                    imgSrc
                }
            }
        }
        totalCount: UserContacts_aggregate {
            aggregate {
                count
            }
        }
    }
`);

export const GET_ALL_USER_CONTACTS = gql(`
    query GetAllUserContacts(
        $orderBy: [UserContacts_order_by!] = [{createdAt: desc}]
    ) {
        UserContacts(
            order_by: $orderBy
        ) {
            id
            prospectId
            status
            createdAt
            _GroupToUserContacts {
                Group {
                    id
                    name
                    imgSrc
                }
            }
        }
        totalCount: UserContacts_aggregate {
            aggregate {
                count
            }
        }
    }
`);

// export const GET_USER_CONTACTS_BY_GROUP_IDS = gql(`
//     query GetAllUserContactsByGroupIds(
//         $groupIds: [String!],
//         $limit: Int! = 10,
//         $offset: Int! = 0,
//         $orderBy: [UserContacts_order_by!] = [{createdAt: desc}]
//     ) {
//         UserContacts(
//             limit: $limit,
//             offset: $offset,
//             order_by: $orderBy,
//             where: {
//                 groupId: {_in: $groupIds}
//             }
//         ) {
//             id
//             prospectId
//             status
//             _GroupToUserContacts {
//                 Group {
//                     id
//                     name
//                     imgSrc
//                 }
//             }
//         }
//         totalCount: UserContacts_aggregate {
//             aggregate {
//                 count
//             }
//         }
//     }
// `);

export const GET_ACTIONS_COUNT = gql(`
    query GetActionsCount($notYetSent: Boolean! = true, $scheduledOnLt: timestamp!) {
        OutreachSuggestions_aggregate(where: {Message: {sentOn: {_is_null: $notYetSent}}, scheduledOn: {_lt: $scheduledOnLt}}) {
          aggregate {
            count
          }
        }
    }
`);

export const GET_PLAYBOOKS = gql(`
    query GetPlaybooks($name: String) {
        Groups(where: {name: {_ilike: $name}}, order_by: {createdAt: asc}) {
            id
            userId
            default
            name
            assistantSettingsId
            imgSrc
            createdAt
            updatedAt
            AssistantSetting {
                id
                userId
                organizationId
                purpose
                language
                languages
                tone
                targetGroup
                context
                createdAt
                updatedAt
                defaultChannel
            }
        }
}
`);

export const GET_PLAYBOOK_BY_GROUP_ID = gql(`
    query GetPlaybookByGroupId($groupId: String!) {
        Groups(where: {id: {_eq: $groupId}}) {
            id
            userId
            default
            name
            assistantSettingsId
            imgSrc
            createdAt
            updatedAt
            AssistantSetting {
                id
                userId
                organizationId
                purpose
                language
                languages
                tone
                context
                targetGroup
                createdAt
                updatedAt
                defaultChannel
            }
            _GroupToUserContacts {
                UserContact {
                  id
                }
            }
        }
    }
`);

export const GET_PERFORMANCE_METRICS = gql(`
    query GetOutreachCompletionMetrics($startDate: timestamp!, $endDate: timestamp!, $organizationId: String!) {
        OutreachCompletionMetrics(
            where: { _and: [{ date: { _gte: $startDate } }, { date: { _lte: $endDate } }, { organizationId: { _eq: $organizationId } }] }
            order_by: { date: asc }
        ) {
            date
            trailingTotalCompleted
            trailingTotalGoalsReached
            trailingTotalSuggestions
            completedSameDay
            completedWithin2Days
            completedWithin3Days
            completedWithin7Days
            completedWithin30Days
            goalsReachedSameDay
            goalsReachedWithin2Days
            goalsReachedWithin3Days
            goalsReachedWithin7Days
            goalsReachedWithin30Days
            suggestionsSameDay
            suggestionsWithin2Days
            suggestionsWithin3Days
            suggestionsWithin7Days
            suggestionsWithin30Days
        }
        numberOfUsers: OutreachSuggestions_aggregate(distinct_on: userId) {
            aggregate {
              count
            }
        }
        numberOfUsersBeforePeriod: OutreachSuggestions_aggregate(distinct_on: userId, where: {createdAt: {_lt: $startDate}}) {
            aggregate {
              count
            }
        }
    }
`);
export const GET_DASHBOARD_METRICS = gql(`
query GetDashboardMetrics($startDate: timestamp!, $endDate: timestamp!, $previousStartDate: timestamp!, $organizationId: String!) {
  numberOfSentMessages: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "out"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      isSentFromApp
      userId
      channelType
      sentOn
    }
  }
  numberOfReceivedMessages: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      userId
      channelType
      sentOn
    }
  }
  numberOfNewConnections: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_eq: "LINKEDIN_CONNECTION_REQUEST_ACCEPTED"}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      prospectFullName
      userId
      channelType
      actionType
      sentOn
    }
  }
  numberOfSentMessagesPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "out"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      isSentFromApp
      userId
      channelType
      sentOn
    }
  }
  numberOfReceivedMessagesPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      userId
      channelType
      sentOn
    }
  }
  numberOfNewConnectionsPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_eq: "LINKEDIN_CONNECTION_REQUEST_ACCEPTED"}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      prospectFullName
      userId
      channelType
      actionType
      sentOn
    }
  }
}`);

export const GET_TEAM_DASHBOARD_METRICS = gql(`
query GetTeamDashboardMetrics($startDate: timestamp!, $endDate: timestamp!, $previousStartDate: timestamp!, $organizationId: String!) {
  numberOfSentMessages: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "out"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      isSentFromApp
      userId
      channelType
      sentOn
    }
  }
  numberOfReceivedMessages: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      userId
      channelType
      sentOn
    }
  }
  numberOfNewConnections: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $startDate}}, {sentOn: {_lte: $endDate}}, {actionType: {_eq: "LINKEDIN_CONNECTION_REQUEST_ACCEPTED"}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      prospectFullName
      userId
      channelType
      actionType
      sentOn
    }
  }
  numberOfSentMessagesPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "out"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      isSentFromApp
      userId
      channelType
      sentOn
    }
  }
  numberOfReceivedMessagesPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_in: ["LINKEDIN_MESSAGE", "EMAIL_MESSAGE"]}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      userId
      channelType
      sentOn
    }
  }
  numberOfNewConnectionsPrev: Messages_aggregate(where: {_and: [{organizationId: {_eq: $organizationId}},{direction: {_eq: "in"}}, {sentOn: {_is_null: false}}, {sentOn: {_gte: $previousStartDate}}, {sentOn: {_lt: $startDate}}, {actionType: {_eq: "LINKEDIN_CONNECTION_REQUEST_ACCEPTED"}}]}) {
    aggregate {
      count
    }
    nodes {
      prospectId
      prospectFullName
      userId
      channelType
      actionType
      sentOn
    }
  }
}`);

export const GET_MESSAGES_SENT_TODAY = gql(`
query GetMessagesSentToday($startDate: timestamp!, $endDate: timestamp!) {
  Messages_aggregate(where: {isSentFromApp: {_eq: true}, direction: {_eq: "out"}, sentOn: {_gte: $startDate, _lte: $endDate}}) {
    aggregate {
      count
    }
  }
}
`);

export const GET_CONVERSATIONS_BY_METADATA = gql(`
query GetConversationsByMetadata($metadata: jsonb) {
  Conversations(where: {metadata: {_eq: $metadata}}) {
    id
    prospectId
    contactId
    createdAt
    updatedAt
    metadata
  }
}
`);

export const GET_MESSAGES_BY_CONVERSATION_METADATA = gql(`
query GetMessagesByConversationMetadata($metadata: jsonb) {
  Messages(where: {metadata: {_eq: $metadata}}) {
    id
    conversationId
    sentOn
    fullName
    content
    actionType
    channelType
  }
}
`);

export const GET_MESSAGES_BY_METADATA_FILTERS = gql(`
query GetMessagesByMetadataFilters(
  $where: Messages_bool_exp!
  $limit: Int = 200
) {
  Messages(
    where: $where
    limit: $limit
    order_by: [{ prospectId: asc }, { sentOn: desc }]
  ) {
    id
    prospectId
    conversationId
    sentOn
    fullName
    content
    actionType
    channelType
    metadata
  }
}
`);

export const GET_UNIQUE_MESSAGE_METADATA_VALUES = gql(`
query GetUniqueMessageMetadataValues {
  Messages(
    where: {
      _and: [
        { metadata: { _is_null: false } }
        { prospectId: { _is_null: false } }
      ]
    }
    limit: 1000
    order_by: [{ sentOn: desc }]
  ) {
    metadata
  }
}
`);

export const GET_CONVERSATIONS_BY_METADATA_FILTERS = gql(`
query GetConversationsByMetadataFilters(
  $where: Conversations_bool_exp!
  $limit: Int = 200
) {
  Conversations(
    where: $where
    limit: $limit
    order_by: [{ prospectId: asc }, { updatedAt: desc }]
  ) {
    id
    prospectId
    contactId
    createdAt
    updatedAt
    metadata
    metadataLastUpdatedAt
  }
}
`);

export const GET_UNIQUE_CONVERSATION_METADATA_VALUES = gql(`
query GetUniqueConversationMetadataValues {
  Conversations(
    where: {
      _and: [
        { metadata: { _is_null: false } }
        { prospectId: { _is_null: false } }
      ]
    }
    limit: 1000
    order_by: [{ updatedAt: desc }]
  ) {
    metadata
  }
}
`);

export const GET_CONTACTS_WEIGHTED_SCORES = gql(`
query GetContactsWeightedScores(
  $where: Contacts_bool_exp! = {}
  $urgent_followup_boost: numeric = 1, 
  $networking_objective_weight: numeric = 1, 
  $sales_objective_weight: numeric = 1, 
  $customer_success_objective_weight: numeric = 1, 
  $fundraising_objective_weight: numeric = 1, 
  $recruiting_objective_weight: numeric = 1, 
  $internal_objective_weight: numeric = 1, 
  $timing_urgency_max_boost: numeric = 0.5, 
  $no_action_penalty: numeric = 0.05,
  $shelf_base_boost: numeric = 1.0,
  $shelf_period_days: numeric = 14.0,
  $very_old_overdue_base_boost: numeric = 0.9,
  $very_old_decay_rate: numeric = 3.0,
  $due_today_boost: numeric = 0.8,
  $due_curve_width: numeric = 1.5,
  $future_penalty: numeric = 0.984,
  $future_decay_rate: numeric = 0.5,
  $limit: Int = 200
  $offset: Int = 0
) {
  contacts_weighted_scores(args: {
    urgent_followup_boost: $urgent_followup_boost, 
    networking_objective_weight: $networking_objective_weight, 
    sales_objective_weight: $sales_objective_weight, 
    customer_success_objective_weight: $customer_success_objective_weight, 
    fundraising_objective_weight: $fundraising_objective_weight, 
    recruiting_objective_weight: $recruiting_objective_weight, 
    internal_objective_weight: $internal_objective_weight, 
    timing_urgency_max_boost: $timing_urgency_max_boost, 
    no_action_penalty: $no_action_penalty,
    shelf_base_boost: $shelf_base_boost,
    shelf_period_days: $shelf_period_days,
    very_old_overdue_base_boost: $very_old_overdue_base_boost,
    very_old_decay_rate: $very_old_decay_rate,
    due_today_boost: $due_today_boost,
    due_curve_width: $due_curve_width,
    future_penalty: $future_penalty,
    future_decay_rate: $future_decay_rate
  }, 
    where: $where, 
    limit: $limit,
    offset: $offset,
    order_by: {compositeScore: desc}
  ) {
    id
    userId
    organizationId
    prospectId
    source
    sourceId
    personId

    firstName
    lastName
    fullName
    location
    email
    phoneNumbers
    skills
    interests

    linkedinProfileUrl
    linkedinUserId
    linkedinProfileImgUrl
    linkedinNumberOfConnections
    linkedinHeadline
    linkedinVerifiedAt

    occupationTitle
    organizationName
    organizationDomain
    organizationLinkedinUrl
    organizationIndustry
    organizationSize

    experiences
    education

    metadataLastUpdatedAt
    metadata

    userSetAsNotInterestedAt

    priorityScore
    compositeScore
    topActionType
    objectiveScores: metadata(path: "objectiveScores")
    contactType: metadata(path: "contactType")
    relationshipType: metadata(path: "relationshipType")
    recommendedActions: actionsMetadata(path: "recommendedActions")
    urgent: metadata(path: "urgentFollowUp")
    region

    connectionStatus
    connectedAt
    snoozedUntil
    lastCompletedActionAt
    nextActionSuggestedAt

    lastContactedAt
    accountId

    numberOfMessages: Messages_aggregate {
      aggregate {
        count
      }
    }

    Messages(order_by: {sentOn: desc_nulls_last}, limit: 1) {
      id
      content
      subjectLine
      sentOn
      prospectFullName
      fullName
      direction
    }
  }
  
  # Total count of all contacts that meet base criteria
  total_contacts: Contacts_aggregate(where: {
    _not: $where
  }) {
    aggregate {
      count
    }
  }
  
  # Count of contacts matching the current filter
  filtered_contacts_count: contacts_weighted_scores_aggregate(
    args: {
      urgent_followup_boost: $urgent_followup_boost, 
      networking_objective_weight: $networking_objective_weight, 
      sales_objective_weight: $sales_objective_weight, 
      customer_success_objective_weight: $customer_success_objective_weight, 
      fundraising_objective_weight: $fundraising_objective_weight, 
      recruiting_objective_weight: $recruiting_objective_weight, 
      internal_objective_weight: $internal_objective_weight, 
      timing_urgency_max_boost: $timing_urgency_max_boost, 
      no_action_penalty: $no_action_penalty,
      shelf_base_boost: $shelf_base_boost,
      shelf_period_days: $shelf_period_days,
      very_old_overdue_base_boost: $very_old_overdue_base_boost,
      very_old_decay_rate: $very_old_decay_rate,
      due_today_boost: $due_today_boost,
      due_curve_width: $due_curve_width,
      future_penalty: $future_penalty,
      future_decay_rate: $future_decay_rate
    },
    where: $where
  ) {
    aggregate {
      count
    }
  }
}
`);

export const GET_CONTACT_AND_CONVERSATION_BY_ID = gql(`
query GetContactAndConversationById($id: String!, $messageLimit: Int = 20, $noteLimit: Int = 20) {
  Contacts_by_pk(id: $id) {
    id
    userId
    organizationId
    prospectId
    source
    sourceId
    personId

    firstName
    lastName
    fullName
    location
    email
    phoneNumbers
    skills
    interests

    linkedinProfileUrl
    linkedinUserId
    linkedinProfileImgUrl
    linkedinNumberOfConnections
    linkedinHeadline
    linkedinVerifiedAt
    connectionStatus
    connectedAt

    occupationTitle
    organizationName
    organizationDomain
    organizationLinkedinUrl
    organizationIndustry
    organizationSize

    experiences
    education

    metadata
    metadataLastUpdatedAt

    actionsMetadata
    priorityScore
    topActionType
    objectiveScores: metadata(path: "objectiveScores")
    contactType: metadata(path: "contactType")
    relationshipType: metadata(path: "relationshipType")
    recommendedActions: actionsMetadata(path: "recommendedActions")
    region

    connectedAt
    snoozedUntil
    lastCompletedActionAt
    nextActionSuggestedAt

    lastContactedAt
    accountId

    numberOfMessages: Messages_aggregate {
      aggregate {
        count
      }
    }

    conversationMetadata: Conversations {
      metadata(path: "conversationSummary")
    }

    Messages(where: {sentOn: {_is_null: false}}, limit: $messageLimit, order_by: {sentOn: asc}) {
      id
      direction
      conversationId
      prospectId
      contactId
      channelType
      actionType
      contentType
      subjectLine
      content
      sentOn
      fullName
      channelType
      linkedinUserId
      externalMessageId
      prospectFullName
      deliveryStatus
      Attachments {
          type
          value
        }
    }
    Notes(limit: $noteLimit, order_by: {happenedOn: desc_nulls_first}, where: {discarded: {_is_null: false}}) {
      id
      title
      content
      createdAt
      creator
      happenedOn
    }
    _GroupToContacts {
      Group {
        id
      }
    }
  }
}`);

export const GET_TOTAL_NUMBER_OF_CONTACTS = gql(`
query GetTotalNumberOfContacts {
  Contacts_aggregate {
    aggregate {
      count
    }
  }
}`);

export const LIST_CONTACTS = gql(`
query GetContactsForTable(
  $limit: Int!
  $offset: Int!
  $orderBy: [Contacts_order_by!]!
  $where: Contacts_bool_exp!
) {
  Contacts(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $where
  ) {
    id
    userId
    organizationId
    prospectId
    source
    sourceId
    personId

    firstName
    lastName
    fullName
    location
    email
    phoneNumbers
    skills
    interests

    linkedinProfileUrl
    linkedinUserId
    linkedinProfileImgUrl
    linkedinNumberOfConnections
    linkedinHeadline
    linkedinVerifiedAt

    occupationTitle
    organizationName
    organizationDomain
    organizationLinkedinUrl
    organizationIndustry
    organizationSize

    experiences
    education

    metadata
    metadataLastUpdatedAt

    actionsMetadata
    priorityScore
    topActionType
    region

    connectedAt
    snoozedUntil
    lastCompletedActionAt
    nextActionSuggestedAt

    lastContactedAt
    accountId
    createdAt

    _GroupToContacts {
      Group {
        id
        name
        imgSrc
        default
        assistantSettingsId
        createdAt
        updatedAt
      }
    }
  }
  
  Contacts_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`);

export const GET_CONTACT_BY_ID = gql(`
query GetContactById($id: String!) {
  Contacts_by_pk(id: $id) {
    id
    userId
    organizationId
    prospectId
    source
    sourceId
    personId

    firstName
    lastName
    fullName
    location
    email
    phoneNumbers
    skills
    interests

    linkedinProfileUrl
    linkedinUserId
    linkedinProfileImgUrl
    linkedinNumberOfConnections
    linkedinHeadline
    linkedinVerifiedAt

    occupationTitle
    organizationName
    organizationDomain
    organizationLinkedinUrl
    organizationIndustry
    organizationSize

    experiences
    education

    metadata

    actionsMetadata
    priorityScore
    topActionType
    objectiveScores: metadata(path: "objectiveScores")
    contactType: metadata(path: "contactType")
    relationshipType: metadata(path: "relationshipType")
    recommendedActions: actionsMetadata(path: "recommendedActions")
    region

    connectedAt
    daysSinceLastMsg

    lastContactedAt
    accountId
  }
}`);
export const GET_CONTACT_BY_IDS = gql(`
query GetContactByIds($ids: [String!]!) {
  Contacts(where: {id: {_in: $ids}}) {
    id
    userId
    organizationId
    prospectId
    source
    sourceId
    personId

    firstName
    lastName
    fullName
    location
    email
    phoneNumbers
    skills
    interests

    linkedinProfileUrl
    linkedinUserId
    linkedinProfileImgUrl
    linkedinNumberOfConnections
    linkedinHeadline
    linkedinVerifiedAt

    occupationTitle
    organizationName
    organizationDomain
    organizationLinkedinUrl
    organizationIndustry
    organizationSize

    experiences
    education

    metadata

    actionsMetadata
    priorityScore
    topActionType
    objectiveScores: metadata(path: "objectiveScores")
    contactType: metadata(path: "contactType")
    relationshipType: metadata(path: "relationshipType")
    recommendedActions: actionsMetadata(path: "recommendedActions")
    region

    connectedAt
    daysSinceLastMsg

    lastContactedAt
    accountId
  }
}`);

export const GET_SAMPLE_CONTACTS = gql(`
query GetSampleContacts($limit: Int, $offset: Int, $orderBy: [SampleContacts_order_by!] = [{updatedAt: desc}]) {
  SampleContacts(limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    contact
    conversation
    createdAt
    updatedAt
  }
  SampleContacts_aggregate {
    aggregate {
      count
    }
  }
}`);

export const GET_LATEST_MESSAGE_DRAFT_ONE = gql(`
    query GetLatestMessageDraftOne($contactId: String!) {
        MessageDrafts(
            where: {
                contactId: { _eq: $contactId }
                archivedAt: { _is_null: true }
            }
            order_by: { updatedAt: desc }
            limit: 1
        ) {
            id
            content
            subjectLine
            channelType
            source
            userPrompt
            updatedAt
        }
    }
`);

export const GET_AUTO_GENERATE_DRAFT_DATA = gql(`
    query GetAutoGenerateDraftData($contactId: String!) {
        Contacts_by_pk(id: $contactId) {
            id
            lastCompletedActionAt
            latestMessage: Messages(
                where: {
                    sentOn: { _is_null: false }
                }
                order_by: { sentOn: desc }
                limit: 1
            ) {
                id
                sentOn
                content
                subjectLine
                actionType
            }
            
            latestDraft: MessageDrafts(
                where: {
                    archivedAt: { _is_null: true }
                }
                order_by: { updatedAt: desc }
                limit: 1
            ) {
                id
                updatedAt
                content
                subjectLine
                channelType
                source
                createdAt
            }
        }
    }
`);

export const GET_CONTACT_CLASSIFICATION = gql(`
query GetContactClassification($id: String!) {
  Contacts_by_pk(id: $id) {
    id
    metadata
    actionsMetadata
    priorityScore
    topActionType
    nextActionSuggestedAt
    snoozedUntil
    conversationMetadata: Conversations {
      metadata
    }
    messagesMetadata: Messages {
      metadata
    }
  }
}`);

export const GET_CONTACTS_INTERACTIONS = gql(`
query GetContactsInteractions {
  notInterestedInteractions: ContactsInteractions(
    where: {interactionType: {_eq: "NOT_INTERESTED"}}, 
    order_by: {createdAt: desc}, 
    limit: 10
  ) {
    id
    contactId
    metadata
    weights
    interactionType
    createdAt
  }
  otherInteractions: ContactsInteractions(
    where: {interactionType: {_neq: "NOT_INTERESTED"}}, 
    order_by: {createdAt: desc}, 
    limit: 30
  ) {
    id
    contactId
    metadata
    weights
    interactionType
    createdAt
  }
}`);

export const SEARCH_CONTACT_PROFILES = gql(`
query GetContactProfiles($limit: Int!, $search: String) {
  Contacts(
    order_by: {metadataLastUpdatedAt: desc}, 
    limit: $limit,
    where: {
        _or: [
          { fullName: { _ilike: $search } },
          {organizationName: { _ilike: $search } },
          {occupationTitle: { _ilike: $search } }
        ]
    }
  ) {
    id
    firstName
    lastName
    fullName
    linkedinProfileImgUrl
    occupationTitle
    organizationName
  }
}`);

export const GET_NUMBER_OF_URGENT_ACTIONS = gql(`
query GetNumberOfUrgentActions {
  urgentContacts: Contacts_aggregate(where: {metadata: {_contains: {urgentFollowUp: true}}}) {
    aggregate {
      count
    }
  }
}`);

export const GET_CONVERSATIONS_WITH_CONTACTS_QUERY = gql(`
    query GetConversationsWithContactsQuery(
        $limit: Int = 25
        $offset: Int = 0
        $where: Conversations_bool_exp = {}
    ) {
        Conversations(
            limit: $limit
            offset: $offset
            where: $where
            order_by: [
                { 
                    Messages_aggregate: { 
                        max: { 
                            sentOn: desc_nulls_last 
                        } 
                    } 
                }
            ]
        ) {
            id
            userId
            organizationId
            prospectId
            contactId
            
            # Contact information
            Contact {
                id
                userId
                organizationId
                prospectId
                firstName
                lastName
                fullName
                linkedinProfileImgUrl
                linkedinUserId
                occupationTitle
                organizationName
                nextActionSuggestedAt
                snoozedUntil
                
                # Group information via mapping table
                _GroupToContacts {
                    # Contact is actually the group, wrong naming in db
                    Group {
                        id
                    }
                }
            }
            
            # Latest message for conversation preview
            Messages(
                where: { sentOn: { _is_null: false } }
                order_by: { sentOn: desc }
                limit: 1
            ) {
                id
                content
                subjectLine
                sentOn
                direction
                actionType
                channelType
                deliveryStatus
            }
        }
    }
`);

export const GET_CONVERSATION_COUNTS_BY_GROUPS = gql(`
    query GetConversationCountsByGroups($availableGroupIds: [String!]!) {
        # Total count of conversations with messages
        totalCount: Conversations_aggregate(
            where: {
                Messages: { sentOn: { _is_null: false } }
            }
        ) {
            aggregate {
                count
            }
        }
        
        # Count for unassigned conversations (contacts with no groups or groups not in available list)
        unassignedCount: Conversations_aggregate(
            where: {
                Messages: { sentOn: { _is_null: false } }
                _or: [
                    {
                        Contact: {
                            _GroupToContacts: { Group: { id: { _is_null: true } } }
                        }
                    },
                    # Contacts with groups that are not in the available groups list
                    {
                        Contact: {
                            _not: {
                                _GroupToContacts: {
                                    Group: { id: { _in: $availableGroupIds } }
                                }
                            }
                        }
                    }
                ]
            }
        ) {
            aggregate {
                count
            }
        }
    }
`);

export const GET_CONVERSATION_COUNT_BY_GROUP = gql(`
    query GetConversationCountByGroup($groupId: String!) {
        groupCount: Conversations_aggregate(
            where: {
                Messages: { sentOn: { _is_null: false } }
                Contact: {
                    _GroupToContacts: {
                        Group: { id: { _eq: $groupId } }
                    }
                }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`);

export const GET_CONTACTS_RECENTLY_CHANGED_JOBS = gql(`
  query GetContactsByStartDatePattern($pattern: String!) {
  Contacts(
    where: {
      experiences: {
        _cast: {
          String: {
            _iregex: $pattern
          }
        }
      }
    },
    limit:1
  ) {
    id
    firstName
    lastName
    fullName
    experiences
    occupationTitle
    organizationName
    linkedinProfileUrl
    linkedinProfileImgUrl
  }
}
`);
